import createDuck from '../../lib/ducks/remoteDuck'
import Cart from '../../lib/api/cart'

export default createDuck({
  namespace: 'account',
  store: 'cart',
  fetchCallback: (options) => Cart.get(options),
})
